import * as React from 'react';
import styled from 'styled-components';
import {observer} from 'mobx-react';
import UserStore from 'stores/UserStore';
import {getImageByPreview} from 'api/library';
import SidebarContext from '../../../SidebarContext';

const Container = styled.div`
  display: flex;
  padding: 5px;
  border-radius: 50%;
  border: 2px solid ${({theme}) => `
    ${theme.colors.primary};
  `};
`;

const Image = styled.img<{
  isToggle?: boolean;
}>`
  object-fit: cover;
  border-radius: 50%;
  height: ${({isToggle}) => isToggle ? '86px' : '38px'};
  width: ${({isToggle}) => isToggle ? '86px' : '38px'};
`;

/**
 * This component renders the avatar of the current user.
 * @return {React.ReactElement}
 * @constructor
 */
function Avatar(): React.ReactElement {
  const context = React.useContext(SidebarContext);

  return (
    <Container>
      <Image
        src={getImageByPreview(UserStore.state?.avatar)}
        isToggle={context?.isToggle}
      />
    </Container>
  );
}

export default observer(Avatar);
